import { render, staticRenderFns } from "./VoteBrowsing.vue?vue&type=template&id=4b31cec1&scoped=true"
import script from "./VoteBrowsing.vue?vue&type=script&lang=js"
export * from "./VoteBrowsing.vue?vue&type=script&lang=js"
import style0 from "./VoteBrowsing.vue?vue&type=style&index=0&id=4b31cec1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31cec1",
  null
  
)

export default component.exports